// extracted by mini-css-extract-plugin
export default {"loader":"apiLoader_loader__rU5pD","loaderIcon":"apiLoader_loaderIcon__irHWe","loaderText":"apiLoader_loaderText__Aik7v","suggestion":"apiLoader_suggestion__wpTjY"};